import React, { Suspense } from 'react'; // eslint-disable-line import/no-unresolved, import/no-extraneous-dependencies
import ReactDOM from 'react-dom'; // eslint-disable-line import/no-unresolved, import/no-extraneous-dependencies
import {
    Config,
    EntryPoint,
    SearchManagerDesktop,
    AdvertisementManager,
    DataAttributesUtils,
} from 'of-components';
import onSearch from './onSearch';
import onAdvertisementClick from './onAdvertisementClick';
import LoadingStubGeneral from './LoadingStubGeneral';
import LoadingStubDp from './LoadingStubDp';
import LoadingStubHotel from './LoadingStubHotels';

const {
    brand,
    lang,
    products,
    entryPoint,
    isWMP,
    isDp,
    isHotel,
} = window.reactContext;

const App = React.lazy(() => import(`of-components/dist/widgets/App/App.${brand}.${lang}.js`),);
Config.init(window.reactContext);

const showTabs = entryPoint !== EntryPoint.FLIGHTS && 1 < products.length;
const hasHotel = entryPoint !== EntryPoint.DP && -1 < products.indexOf(EntryPoint.DP);
const container = document.getElementById('react-app');
const rootDataAttr = DataAttributesUtils.getAllDataAttr(container);
const isDeals = entryPoint === EntryPoint.DEALS;

const stub = () => {
    if (isHotel) return <LoadingStubHotel />;
    if (isDp) return <LoadingStubDp />;
    if (isDeals) return null;
    return <LoadingStubGeneral />;
};

if (container) {
    const wmpProductList = container.dataset.productslist || [];
    const wmpActiveTab = container.dataset.activetab || entryPoint;
    ReactDOM.render(
        <Suspense fallback={stub()}>
            <App onSearch={onSearch}>
                { isWMP && (
                    <SearchManagerDesktop
                        wmpProductList={wmpProductList}
                        showTabs={showTabs}
                        isHotelOptionEnabled={hasHotel}
                        entryPoint={wmpActiveTab}
                        rootDataAttr={rootDataAttr}
                    />
                )}
                { !isWMP && (
                    <AdvertisementManager offers={Config.get('deals').offers} offerCallback={onAdvertisementClick}>
                        <SearchManagerDesktop
                            showTabs={showTabs}
                            isHotelOptionEnabled={hasHotel}
                            entryPoint={entryPoint}
                            rootDataAttr={rootDataAttr}
                        />
                    </AdvertisementManager>
                )}
            </App>
        </Suspense>,
        container,
    );
}
